import { createOpportunitiesMachine } from '~/features/shared/createOpportunitiesMachine';
import { API_CALLS } from './api';
import type { JobMessage, JobOpportunity, OpportunityFilter } from './types';

export type OpportunitiesContext = {
  opportunities: JobOpportunity[];
  totalCount: number;
  selectedOpportunity: JobOpportunity | undefined;
  messages: JobMessage[];
  filter: OpportunityFilter;
  loading: boolean;
  messagesLoading: boolean;
  error: string | null;
};

export const jobOpportunitiesMachine = createOpportunitiesMachine<
  JobOpportunity,
  JobMessage,
  OpportunityFilter
>({
  id: 'jobOpportunities',
  defaultFilter: 'all',
  api: {
    getOpportunities: (filter, signal, includeDeclined) =>
      API_CALLS.getOpportunities(filter, signal, includeDeclined),
    getMessages: (responseId, signal) => API_CALLS.getMessages(responseId, signal),
    sendMessage: (responseId, messageBody, signal) =>
      API_CALLS.sendMessage(responseId, messageBody, signal),
    accept: (responseId, expectedNegotiationId, signal) =>
      API_CALLS.updateStatus(responseId, 'ACCEPTED', signal, expectedNegotiationId),
    withdraw: (responseId, signal) => API_CALLS.updateStatus(responseId, 'WITHDRAWN', signal),
  },
});
